import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useEntrepreneurLoginPage = (): React.Ref<HTMLDivElement | null> => {
  const scroller = useRef<HTMLDivElement | null>(null);
  const { state } = useLocation();
  const { trigger } = state || {};

  useEffect(() => {
    if (trigger && scroller?.current) {
      scroller.current.scrollIntoView();
    }
  }, [trigger]);

  return scroller;
};
